import { render, staticRenderFns } from "./MentoringMenu.vue?vue&type=template&id=28035a29&"
import script from "./MentoringMenu.vue?vue&type=script&lang=js&"
export * from "./MentoringMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports